import React from "react";

function Hero() {
  return (
    <section className="text-white bg-[url('./img/banner-3.jpg')] bg-cover bg-center bg-no-repeat min-h-[420px] md:min-h-[480px] flex flex-col justify-center items-center space-y-8 py-14">
      <h3 className="text-2xl font-semibold px-5 text-center">BUILD YOUR CAREER WITH DISCOVER LOAN</h3>
        <p className="px-5 xl:w-[60%] text-center leading-normal text-xl">
        To get the best out of your career, you need the best opportunities. Here at Discover Loan, you have every opportunity to grow as an individual, build lasting relationships and make lasting positive impact. Our people are our strength. We actively recruit, retain, and develop talented, diverse, and adaptable individuals. We believe working together to address issues builds lasting relationships and strengthens trust. We value curious minds because curiosity is essential to lifelong learning. At Discover Loan, we aim to spark a lifelong love for learning in every individual. We learn, we motivate each other, and together we grow.
        </p>
    </section>
  );
}

export default Hero;
